import React from 'react';
import FestivalRouter from './components/FestivalRouter';

const App = () => {
  return <FestivalRouter />;
};

export default App;